import script from "./LottScanWin.vue?vue&type=script&setup=true&lang=js"
export * from "./LottScanWin.vue?vue&type=script&setup=true&lang=js"

import "./LottScanWin.vue?vue&type=style&index=0&id=821c4df6&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-821c4df6"]])

export default __exports__